import { Dialog } from "@/components/ui/dialog";
import { UploadCourseRequestsPanel } from "./upload-course-requests-panel";

interface UploadCourseRequestsDialogProps {
  scheduleId: string;
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Modal wrapper around {@link UploadCourseRequestsPanel} for the schedule
 * home page. Standalone re-upload entry point (the wizard variant is
 * non-modal). Closes on successful import.
 *
 * Escape-to-close and the global dialog stack are handled by the base
 * {@link Dialog} primitive; this wrapper only needs to mount/unmount.
 */
export function UploadCourseRequestsDialog({
  scheduleId,
  isOpen,
  onClose,
}: UploadCourseRequestsDialogProps) {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title="Upload Course Requests"
      description="Replace or append to the existing course-request roster."
      maxWidthClassName="max-w-lg"
      testId="upload-course-requests-dialog"
    >
      <UploadCourseRequestsPanel
        scheduleId={scheduleId}
        showReplaceAllToggle={true}
        onSuccess={onClose}
      />
    </Dialog>
  );
}
